import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';

declare var google;
@Component({
  selector: 'adf-employment-details-form',
  templateUrl: 'employment_details.html',
  providers: [EnvDataService]
})
export class EmploymentDetails {
  @Input() editdata: any;
  @Output() valueChange = new EventEmitter();
  @Output () dateCommence_evtent=new EventEmitter();
  @Output() incomeChange = new EventEmitter();
  @Output() addincomeChange = new EventEmitter(); //valueAddincomeChange
  @Output() valueAddincomeChange = new EventEmitter();
  slideThreeForm: FormGroup;
  primaryData:FormGroup;
  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  firstname1: any;
  public change_log_string: any;
  public employementType;
  public employment_details: any;
  public isCurrentEmployeed;
  public statusEmployment;
  public indexx : number;
  public expectedWork;
  public modeOfOperation:any;
  public showPrimaryApplicantEmployement: number = 1;
  public showAdditional_employement: number = -1;

  public validation_messages = {
    'employementType': [
      { type: 'required', message: 'Employment type required.' }
    ],
    'currentlyEmployment': [
      { type: 'required', message: 'Current employment required.' }
    ],
    'expectFindWork': [
      { type: 'required', message: 'Enter expect find work.' }
    ],
    'statusyourEmployment': [
      { type: 'required', message: 'Status your employment required.' }
    ],
    'your_occupation': [
      { type: 'required', message: 'Your occupation required.' }
    ],
    'start_date': [
      { type: 'required', message: 'When did you start in this role required.' }
    ],
    'business_name': [
      { type: 'required', message: 'Business name required.' }
    ],
    'nature_of_business': [
      { type: 'required', message: 'Nature of business required.' }
    ],

  }



  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];

    this.slideThreeForm = formBuilder.group({
      employementType: ['', Validators.required],
      currentlyEmployment: ['',Validators.required],
      expectFindWork: [''],
      statusyourEmployment: ['',Validators.required],
      your_occupation: ['',Validators.required],
      start_date: ['',Validators.required],
      business_name: [''],
      type_of_entity: [''],
      abn_acn: [''],
      nature_of_business: [''],
      addEmploymentItem:  this.formBuilder.array([]),
      addPrimaryEmploymentItem:  this.formBuilder.array([])
    });

    this.primaryData = formBuilder.group({
      firstname: ['', Validators.compose([Validators.maxLength(30), Validators.minLength(1), Validators.required])],
      middlename: ['', Validators.compose([Validators.maxLength(30)])],
      lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      addAnotherApplicantItem: this.formBuilder.array([])
    })

  }
  ngOnInit() {
  }
  ngOnChanges() {

  }

  initaddAnotherApplicant2() {
    return this.formBuilder.group({

      secondary_firstname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['Life Partner', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: '',
      document_id: ['']
    });
  }


  addAnotherApplicant() {
    this.formApplicantEmployment.push(this.initaddAnotherApplicantEmployment());
    this.primaryApplicantdata.push(this.initaddAnotherApplicant2());

  }


  deleteSecondaryApplicant(index) {
    this.formApplicantEmployment.removeAt(index);

  }

  initaddAnotherApplicantEmployment() {
    return this.formBuilder.group({

      employementType: ['',Validators.required],
      currentlyEmployment: ['',Validators.required],
      statusyourEmployment: ['',Validators.required],
      your_occupation: ['',Validators.required],
      start_date: ['',Validators.required],
      expectFindWork: [''],
      business_name: [''],
      type_of_entity: [''],
      abn_acn: [''],
      nature_of_business: [''],
      deleted: [0],
      previousEmploymentItem: this.formBuilder.array([])
    });
  }

  initaddAnotherApplicantEmployment2(formObj) {
    return this.formBuilder.group({

      employementType: [formObj.employementType,[Validators.required]],
      currentlyEmployment: [formObj.currentlyEmployment,[Validators.required]],
      statusyourEmployment: [formObj.statusyourEmployment,[Validators.required]],
      your_occupation: [formObj.your_occupation,[Validators.required]],
      start_date: [formObj.start_date,[Validators.required]],
      expectFindWork: [formObj.expectFindWork],
      business_name: [formObj.business_name],
      type_of_entity: [formObj.type_of_entity],
      abn_acn: [formObj.abn_acn],
      nature_of_business: [formObj.nature_of_business],
      deleted: [0],
      previousEmploymentItem: this.formBuilder.array([])
    });
  }

  getUserData(e){
   debugger;

   while ((<FormArray>this.slideThreeForm.get('addPrimaryEmploymentItem')).length !== 0) {
    (<FormArray>this.slideThreeForm.get('addPrimaryEmploymentItem')).removeAt(0);
    }

    if(e.contact_details.employment_details) {
      this.slideThreeForm.controls.employementType.setValue(e.contact_details.employment_details.employementType);
    this.slideThreeForm.controls.currentlyEmployment.setValue(e.contact_details.employment_details.currentlyEmployment);
    this.slideThreeForm.controls.expectFindWork.setValue(e.contact_details.employment_details.expectFindWork);
    this.slideThreeForm.controls.statusyourEmployment.setValue(e.contact_details.employment_details.statusyourEmployment);
    this.slideThreeForm.controls.your_occupation.setValue(e.contact_details.employment_details.your_occupation);
    this.slideThreeForm.controls.start_date.setValue(e.contact_details.employment_details.start_date);
    this.slideThreeForm.controls.business_name.setValue(e.contact_details.employment_details.business_name);
    this.slideThreeForm.controls.type_of_entity.setValue(e.contact_details.employment_details.type_of_entity);
    this.slideThreeForm.controls.abn_acn.setValue(e.contact_details.employment_details.abn_acn);
    this.slideThreeForm.controls.nature_of_business.setValue(e.contact_details.employment_details.nature_of_business);

    this.isCurrentEmployeed = e.contact_details.employment_details.currentlyEmployment;
    this.employementType = e.contact_details.employment_details.employementType;

    if(this.isCurrentEmployeed == 'no' && this.employementType == 'payg') {

      this.slideThreeForm.get('statusyourEmployment').clearValidators();
      this.slideThreeForm.get('statusyourEmployment').updateValueAndValidity();

      this.slideThreeForm.get('your_occupation').clearValidators();
      this.slideThreeForm.get('your_occupation').updateValueAndValidity();

      this.slideThreeForm.get('start_date').clearValidators();
      this.slideThreeForm.get('start_date').updateValueAndValidity();

    }

    if(e.contact_details.employment_details.addPrimaryEmploymentItem) {
      if(e.contact_details.employment_details.addPrimaryEmploymentItem.length > 0 ) {

        e.contact_details.employment_details.addPrimaryEmploymentItem.forEach((element,index) => {
          this.formPrimaryEmployment.push(this.initaddAnotherApplicantEmployment2(element));

          let employementType = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('employementType');
            console.log(employementType);
            console.log(element);
            if(element.employementType == 'payg') {
                let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
                gcurrentlyEmployment.clearValidators(); //expectFindWork
                gcurrentlyEmployment.updateValueAndValidity(); //expectFindWork

                let expectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
                expectFindWork.clearValidators(); //expectFindWork
                expectFindWork.updateValueAndValidity(); //expectFindWork


                let business_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');
                business_name.clearValidators(); //expectFindWork
                business_name.updateValueAndValidity(); //expectFindWork


                let nature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');
                nature_of_business.clearValidators(); //expectFindWork
                nature_of_business.updateValueAndValidity(); //expectFindWork

                let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');

                gstatusyourEmployment.setValidators([Validators.required])
                gstatusyourEmployment.updateValueAndValidity()

                let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');

                gyour_occupation.setValidators([Validators.required])
                gyour_occupation.updateValueAndValidity()

                let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');

                gstart_date.setValidators([Validators.required])
                gstart_date.updateValueAndValidity()


            }

            else if(element.employementType == 'self-employed') {

              let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
              gcurrentlyEmployment.clearValidators(); //expectFindWork
              gcurrentlyEmployment.updateValueAndValidity(); //expectFindWork

              let expectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
              expectFindWork.clearValidators(); //expectFindWork
              expectFindWork.updateValueAndValidity(); //expectFindWork


              let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
              gyour_occupation.clearValidators(); //expectFindWork
              gyour_occupation.updateValueAndValidity(); //business_name


              let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
              gstart_date.clearValidators(); //expectFindWork
              gstart_date.updateValueAndValidity(); //nature_of_business

              let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');

              gstatusyourEmployment.clearValidators(); //expectFindWork
              gstatusyourEmployment.updateValueAndValidity(); //nature_of_business

              let business_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');

              business_name.setValidators([Validators.required])
              business_name.updateValueAndValidity()

              let nature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');

              nature_of_business.setValidators([Validators.required])
              nature_of_business.updateValueAndValidity()


            }

            else {
              let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
              gcurrentlyEmployment.clearValidators(); //expectFindWork
              gcurrentlyEmployment.updateValueAndValidity(); //expectFindWork

              let expectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
              expectFindWork.clearValidators(); //expectFindWork
              expectFindWork.updateValueAndValidity(); //expectFindWork


              let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
              gyour_occupation.clearValidators(); //expectFindWork
              gyour_occupation.updateValueAndValidity(); //business_name


              let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
              gstart_date.clearValidators(); //expectFindWork
              gstart_date.updateValueAndValidity(); //nature_of_business

              let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');

              gstatusyourEmployment.clearValidators(); //expectFindWork
              gstatusyourEmployment.updateValueAndValidity(); //nature_of_business

              let business_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');

              business_name.clearValidators(); //expectFindWork
              business_name.updateValueAndValidity(); //nature_of_business

              let nature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');

              nature_of_business.clearValidators(); //expectFindWork
              nature_of_business.updateValueAndValidity(); //nature_of_business


            }


          // let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
          // gcurrentlyEmployment.setValidators(null);
          // gcurrentlyEmployment.updateValueAndValidity();

          // let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
          // gcurrentlyEmployment.clearValidators(); //expectFindWork
          // gcurrentlyEmployment.updateValueAndValidity(); //expectFindWork
          // let expectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
          // expectFindWork.clearValidators(); //expectFindWork
          // expectFindWork.updateValueAndValidity(); //expectFindWork
          // let start_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
          //   start_date.clearValidators(); //expectFindWork
          //   start_date.updateValueAndValidity(); //expectFindWork

          //   let statusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');
          //   statusyourEmployment.clearValidators(); //expectFindWork
          //   statusyourEmployment.updateValueAndValidity(); //expectFindWork

          //   let your_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
          //   your_occupation.clearValidators(); //expectFindWork
          //   your_occupation.updateValueAndValidity(); //expectFindWork

        });

      }
    }
    }


    this.primaryData.controls.firstname.setValue(e.user_data.firstname);
    this.primaryData.controls.lastname.setValue(e.user_data.lastname);



  }

  getAdditionalApplicantUserData(data,index){
    const anotherApplicantEmploymentFormGroup=<FormGroup>this.slideThreeForm.controls["addEmploymentItem"]['controls'][index];
    anotherApplicantEmploymentFormGroup.controls.employementType.setValue(data.contact_details.employment_details.employementType);
  }

  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }


  get formPrimaryEmployment() {
    return this.slideThreeForm.get('addPrimaryEmploymentItem') as FormArray;
  }

  get formApplicantEmployment() {
    return this.slideThreeForm.get('addEmploymentItem') as FormArray;
  }

  AddApplicantEmployment(): FormArray {
    return this.slideThreeForm.get('addEmploymentItem') as FormArray;
  }

  changeLog(event, index: any) {

  }
  collectLogData(event, type, index){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'address_type'){
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if(type == 'street_type'){
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if(type == 'state'){
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if(type == 'country'){
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if(type == 'housing_situation'){
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if(type == 'move_in_date'){
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if(type == 'date_of_birth'){
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }
    if(this.new_val != this.old_val){
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }

  }

  public changeEmploymentType($event, type){

      debugger;
      console.log(this.slideThreeForm);

      let gcurrentlyEmployment = this.slideThreeForm.get('currentlyEmployment');
      let gexpectFindWork = this.slideThreeForm.get('expectFindWork');
      let gstatusyourEmployment = this.slideThreeForm.get('statusyourEmployment');
      let gyour_occupation = this.slideThreeForm.get('your_occupation');
      let gstart_date = this.slideThreeForm.get('start_date');
      let gbusiness_name = this.slideThreeForm.get('business_name');
      let gnature_of_business = this.slideThreeForm.get('nature_of_business');
      if($event == 'payg'){

        this.employementType = $event;
        gbusiness_name.setValidators(null);
        gnature_of_business.setValidators(null);
        gcurrentlyEmployment.setValidators(Validators.required);
        gstart_date.setValidators(Validators.required);
        if(this.modeOfOperation === 'yes')
        {
          if(this.employment_details) {
            if(this.employment_details.employementType == 'self-employed'){
              this.new_val = '';
              this.old_val = this.employment_details.business_name;
              property = 'Business Name';
              if(this.new_val != this.old_val){
                this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
              }
              this.old_val = this.employment_details.type_of_entity;
              property = 'Type of Entity';
              if(this.new_val != this.old_val){
                this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
              }
              this.old_val = this.employment_details.abn_acn;
              property = 'ABN/ACN';
              if(this.new_val != this.old_val){
                this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
              }
              this.old_val = this.employment_details.nature_of_business;
              property = 'Nature of Business';
              if(this.new_val != this.old_val){
                this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
              }
            }
          }

        }
      }else{
        //console.log(this.employment_details);
        debugger;
        this.employementType = $event;

        gcurrentlyEmployment.clearValidators();
        gexpectFindWork.clearValidators();
        gstatusyourEmployment.clearValidators();
        gyour_occupation.clearValidators();
        gstart_date.setValue(null);
        gstart_date.clearValidators();
        gbusiness_name.setValidators(Validators.required);
        gnature_of_business.setValidators(Validators.required);
        this.removePrimaryPreviousEmployment();
        if(this.modeOfOperation === 'yes')
        {
          console.log(this.employment_details);

          if(this.employment_details) {
            if(this.employment_details.employementType == 'payg'){
              this.new_val = '';
              this.old_val = this.employment_details.currentlyEmployment;
              property = 'Currently Employment';
              if(this.new_val != this.old_val){
                this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
              }
              this.old_val = (this.employment_details.statusyouredEmployment == undefined) ? '' : this.employment_details.statusyouredEmployment;
              property = 'What is the status of your employment?';
              if(this.new_val != this.old_val){
                this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
              }
              this.old_val = this.employment_details.your_occupation;
              property = 'Your Occupation';
              if(this.new_val != this.old_val){
                this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
              }
              this.old_val = this.employment_details.start_date;
              property = 'Employment role date';
              if(this.new_val != this.old_val){
                this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
              }
              this.old_val = this.employment_details.expectFindWork;
              property = 'In how long do you expect to find work?';
              if(this.new_val != this.old_val){
                this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
              }
            }
          }

        }
      }
      gcurrentlyEmployment.updateValueAndValidity();
      gexpectFindWork.updateValueAndValidity();
      gstatusyourEmployment.updateValueAndValidity();
      gyour_occupation.updateValueAndValidity();
      gstart_date.updateValueAndValidity();
      gbusiness_name.updateValueAndValidity();
      gnature_of_business.updateValueAndValidity();


      this.new_val = $event;
      this.old_val = '';
      var property = '';
      if(this.modeOfOperation === 'yes')
      {
        if(type == 'employementType'){

          if(this.employment_details) {
            this.old_val = (this.employment_details.employementType == undefined) ? '' : this.employment_details.employementType;
            property = 'Employement Type';
          }

        }
      }
      if(this.new_val != this.old_val){
        this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
      }

      console.log(this.slideThreeForm);
      debugger;

  }

  public changeEmploymentTypeaddi($event,empInd) {
    console.log(this.slideThreeForm);

    debugger;

    let gcurrentlyEmployment = (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(empInd).get('currentlyEmployment');
    let gexpectFindWork = (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(empInd).get('expectFindWork');
    let gstatusyourEmployment = (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(empInd).get('statusyourEmployment');
    let gyour_occupation = (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(empInd).get('your_occupation');
    let gstart_date = (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(empInd).get('start_date');
    let gbusiness_name = (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(empInd).get('business_name');
    let gnature_of_business = (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(empInd).get('nature_of_business');
    if($event == 'payg'){

      this.employementType = $event;
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      gcurrentlyEmployment.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      if(this.modeOfOperation === 'yes')
      {
        if(this.employment_details.employementType == 'self-employed'){
          this.new_val = '';
          this.old_val = this.employment_details.business_name;
          property = 'Business Name';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = this.employment_details.type_of_entity;
          property = 'Type of Entity';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = this.employment_details.abn_acn;
          property = 'ABN/ACN';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = this.employment_details.nature_of_business;
          property = 'Nature of Business';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
        }
      }
    }else{
      //this.employementType = $event;

      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValue(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(Validators.required);
      gnature_of_business.setValidators(Validators.required);
      this.removeAdditionalPreviousEmployment(empInd);
      if(this.modeOfOperation === 'yes')
      {
        if(this.employment_details.employementType == 'payg'){
          this.new_val = '';
          this.old_val = this.employment_details.currentlyEmployment;
          property = 'Currently Employment';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = (this.employment_details.statusyouredEmployment == undefined) ? '' : this.employment_details.statusyouredEmployment;
          property = 'What is the status of your employment?';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = this.employment_details.your_occupation;
          property = 'Your Occupation';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = this.employment_details.start_date;
          property = 'Employment role date';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = this.employment_details.expectFindWork;
          property = 'In how long do you expect to find work?';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
        }
      }
    }
    gcurrentlyEmployment.updateValueAndValidity();
    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();


    this.new_val = $event;
    this.old_val = '';
    var property = '';
    if(this.modeOfOperation === 'yes')
    {
      if(empInd == 'employementType'){
        this.old_val = (this.employment_details.employementType == undefined) ? '' : this.employment_details.employementType;
        property = 'Employement Type';
      }
    }
    if(this.new_val != this.old_val){
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
    }

    console.log(this.slideThreeForm);
    debugger;

  }

  primaryApplicantEmployement(event){
    this.showPrimaryApplicantEmployement = 1;
    this.showAdditional_employement = -1;

  }

  editprimaryApplicantEmployement(){
    this.showPrimaryApplicantEmployement = 1;
    this.showAdditional_employement = -1;

  }
  employementOfApplicant(event, index){
    this.showPrimaryApplicantEmployement = 0;
    this.showAdditional_employement = index;

  }

  employementOfApplicant2(index){
    this.showPrimaryApplicantEmployement = 0;
    this.showAdditional_employement = index;

  }

  public currentEmployeed(value, type){
    let gexpectFindWork = this.slideThreeForm.get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.get('your_occupation');
    let gstart_date = this.slideThreeForm.get('start_date');
    let gbusiness_name = this.slideThreeForm.get('business_name');
    let gnature_of_business = this.slideThreeForm.get('nature_of_business');
    if(value == 'yes'){
      this.isCurrentEmployeed = value;
      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);
      this.incomeChange.emit('yes');
    }else{
      this.isCurrentEmployeed = value;
      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      this.incomeChange.emit('no');
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();

    this.new_val = value;
    this.old_val = '';
    var property = '';
    if(this.modeOfOperation === 'yes'){
      if(type == 'currentlyEmployment'){
        if(this.employment_details) {
          this.old_val = (this.employment_details.currentlyEmployment == undefined) ? '' : this.employment_details.currentlyEmployment;
          property = 'Currently Employment';
        }

      }
    }
    if(this.new_val != this.old_val){

      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val});
    }
  }

  public statusyouredEmployment(value, type, index){
    if(value == 'other'){
      this.statusEmployment = 'other';
    }else{
      this.statusEmployment = '';
    }

    this.new_val = value;
    this.old_val = '';
    var property = '';
    if(index == 'main'){
      if(type == 'statusyourEmployment'){
        this.old_val = (this.applicant_details.statusyourEmployment == undefined) ? '' : this.applicant_details.statusyourEmployment;
        property = 'Status Your Employment';
      }
    }
    if(this.new_val != this.old_val){

      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }
  }

  getRoleStartDate(event, key, con_type, index) {

    //console.log()
    debugger;
    var getDate = event.target.value;
    //this.valueChange.emit(getDate);

    var datesplit = getDate.split("/");
    if (datesplit.length == 3) {
      var newDate = new Date().getTime()
      var oldDate = new Date(datesplit[2] + '-' + datesplit[1] + '-' + datesplit[0] + 'T00:00:00Z')
      console.log(oldDate);
      //oldDate.setMonth(oldDate.getMonth() + 36);
     oldDate.setFullYear(oldDate.getFullYear() + 3)
      var oldDate1 = oldDate.getTime();
      if(con_type == 'primary'){

        var newDate_1 = new Date();
        if(oldDate.getFullYear() < newDate_1.getFullYear()) {
            if(key == 'main') {
              this.removePrimaryPreviousEmployment();
            }
            else {
              this.removePreviousEmployment(key)
            }


        }
        else {
          if(newDate > oldDate1){

            this.removePreviousEmployment(key)

            // if(this.formPrimaryEmployment.length <= 2 ){
            //   this.removePreviousEmployment(key)
            // }

          }
          else {
            if ((this.formPrimaryEmployment.length == 1 && key == "main")) {
            }
            else {
              if (this.formPrimaryEmployment.length == (key + 1)) {
                this.addPreviousEmployment()
              } else if ((this.formPrimaryEmployment.length == 0 && key == "main")) {
                this.addPreviousEmployment()
              }
            }
          }
        }

        // else{
        //   debugger;
        //   if(this.formPrimaryEmployment.length <= 2 ){
        //     this.addPreviousEmployment()

        //   }
        // }
      }else if(con_type == 'additional'){

        var newDate_1 = new Date();
        if(oldDate.getFullYear() < newDate_1.getFullYear()) {
          if(key == 'main') {
            this.removeAdditionalPreviousEmployment(index);
          }
          else {
            this.removeAddPreviousEmployment(key,index);
          }

        }
        else {

          if(newDate > oldDate1){

            this.removeAddPreviousEmployment(key,index);
            // if(this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.length <= 1){
            //   this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.removeAt(key);
            // }


          }else{

            if ((this.additionalAppEmployment(index).length == 1 && key == "main")) {
            }
            else {
              if (this.additionalAppEmployment(index).length == (key + 1)) {

                this.additionalAppEmployment(index).push(this.initaddPreviousEmployment());

              } else if ((this.additionalAppEmployment(index).length == 0 && key == "main")) {
                this.additionalAppEmployment(index).push(this.initaddPreviousEmployment());
              }
            }

            // if(this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.length <= 1){
            //   debugger;
            //   this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.push(this.initaddPrimaryEmployment())

            // }
          }

        }
      }
    }
  }

  changeincomedate(event) {
    var getDate = event.target.value;
    this.valueChange.emit(getDate);
    // if(this.currentdatestatus) {
    //   this.valueChange.emit(getDate);
    //   this.currentdatestatus = false;
    // }
  }
  changeAddincomedate(event,index) {
    debugger;
    console.log(index);
    var getDate = event.target.value;
    let additional_obj = {
      getDate:getDate,
      index:index
    }
    console.log(additional_obj);
    this.valueAddincomeChange.emit(additional_obj);
  }

  additionalAppEmployment(appIndex: number): FormArray {
     console.log(this.AddApplicantEmployment().at(appIndex));
     console.log(this.slideThreeForm);
     debugger;
     return this.AddApplicantEmployment().at(appIndex).get("previousEmploymentItem") as FormArray

  }
  additionalPrimAppEmployment(appIndex: number): FormArray {
    return this.AddApplicantEmployment().at(appIndex).get("addPrimaryEmploymentItem") as FormArray
  }

  removePreviousEmployment(key) {
    if(key > -1){
      for(var i = this.formPrimaryEmployment.length; i > 0; i--){
        if(i > key){
          this.formPrimaryEmployment.removeAt(i);
        }
      }
    }else{
      this.formPrimaryEmployment.removeAt(key);
    }
  }
  removePrimaryPreviousEmployment() {
    while (this.formPrimaryEmployment.length !== 0) {
        this.formPrimaryEmployment.removeAt(0);
      }
  }
  removeAddPreviousEmployment(key,index) {
    console.log(this.formApplicantEmployment.at(index));
    debugger;
    if(key > -1){
      for(var i = this.additionalAppEmployment(index).length; i > 0; i--){
        if(i > key){

          this.additionalAppEmployment(index).removeAt(i);
        }
      }
      // for(var i = (<FormArray>this.slideThreeForm.get('addEmploymentItem')).length; i > 0; i--){
      //   if(i > key){

      //     this.additionalAppEmployment(index).removeAt(i);
      //   }
      // }
    }else{
      this.additionalAppEmployment(index).removeAt(i);
    }
  }
  removeAdditionalPreviousEmployment(index) {
    console.log(this.additionalAppEmployment(index));
    debugger;
    while (this.additionalAppEmployment(index).length !== 0) {
      this.additionalAppEmployment(index).removeAt(0);
    }
  }

  currentEmployeedAddiPrev(value, index, index1){
    let gexpectFindWork = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('expectFindWork');
    let gstatusyourEmployment = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('statusyourEmployment');
    let gyour_occupation = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('your_occupation');
    let gstart_date = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('start_date');
    let gbusiness_name = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('business_name');
    let gnature_of_business = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('nature_of_business');
    if(value == 'yes'){

      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);
    }else{

      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();

  }


  changeEmploymentTypeAddiPrev($event, index, index1){
    debugger;
    console.log(this.formApplicantEmployment.controls[index]);
    // let gcurrentlyEmployment = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('currentlyEmployment');
    // let gexpectFindWork = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('expectFindWork');
    let gstatusyourEmployment = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('statusyourEmployment');//
    let gyour_occupation = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('your_occupation');//
    let gstart_date = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('start_date'); //
    let gbusiness_name = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('business_name');
    let gnature_of_business = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('nature_of_business');
    if($event == 'payg'){

      // gcurrentlyEmployment.setValidators(null);
      // gexpectFindWork.setValidators(null);
      gbusiness_name.clearValidators();
      gbusiness_name.updateValueAndValidity();

      gnature_of_business.clearValidators();
      gnature_of_business.updateValueAndValidity();

      gstatusyourEmployment.setValidators([Validators.required])
      gstatusyourEmployment.updateValueAndValidity()

      gyour_occupation.setValidators([Validators.required])
      gyour_occupation.updateValueAndValidity()

      gstart_date.setValidators([Validators.required])
      gstart_date.updateValueAndValidity()


      // gbusiness_name.setValidators(null);
      // gnature_of_business.setValidators(null);
      //gcurrentlyEmployment.setValidators(Validators.required);
    }else if($event == 'unemployed'){

      // gcurrentlyEmployment.setValidators(null);
      // gexpectFindWork.setValidators(null);
      gstatusyourEmployment.clearValidators();
      gstatusyourEmployment.updateValueAndValidity();

      gyour_occupation.clearValidators();
      gyour_occupation.updateValueAndValidity();

      gstart_date.clearValidators();
      gstart_date.updateValueAndValidity();

      gbusiness_name.clearValidators();
      gbusiness_name.updateValueAndValidity();

      gnature_of_business.clearValidators();
      gnature_of_business.updateValueAndValidity();
      //gcurrentlyEmployment.setValidators(null);
      //gexpectFindWork.setValidators(null);
      // gstatusyourEmployment.setValidators(null);
      // gyour_occupation.setValidators(null);
      // gstart_date.setValidators(null);
      // gbusiness_name.setValidators(null);
      // gnature_of_business.setValidators(null);
      this.removeAddPreviousEmployment(index,index1);
    }else{

      //  gcurrentlyEmployment.setValidators(null);
      //  gexpectFindWork.setValidators(null);
      gstatusyourEmployment.clearValidators();
      gstatusyourEmployment.updateValueAndValidity();

      gyour_occupation.clearValidators();
      gyour_occupation.updateValueAndValidity();

      gstart_date.clearValidators();
      gstart_date.updateValueAndValidity();

      gbusiness_name.setValidators(Validators.required);
      gnature_of_business.setValidators(Validators.required);
      this.removeAddPreviousEmployment(index,index1);
    }

  }

  addPreviousEmployment() {
    this.formPrimaryEmployment.push(this.initaddPrimaryEmployment());
    this.indexx = this.formPrimaryEmployment.length-1;
  }

  initaddPrimaryEmployment() {
    return this.formBuilder.group({

      employementType: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      currentlyEmployment: ['', Validators.compose([Validators.maxLength(30)])],
      statusyourEmployment: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      your_occupation: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      start_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      expectFindWork: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      business_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      type_of_entity: [''],
      abn_acn: ['', Validators.compose([Validators.maxLength(30)])],
      nature_of_business: ['', Validators.compose([Validators.maxLength(30)])],
      deleted: [0]
    });
  }

  initaddPreviousEmployment() {
    return this.formBuilder.group({

      employementType: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      statusyourEmployment: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      your_occupation: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      start_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      business_name: ['', Validators.compose([Validators.maxLength(30)])],
      type_of_entity: [''],
      abn_acn: ['', Validators.compose([Validators.maxLength(30)])],
      nature_of_business: ['', Validators.compose([Validators.maxLength(30)])],
      deleted: [0]
    });
  }

  public expectedFindWork(value){
    if(value == 'other'){
      this.expectedWork = 'other';
    }else{
      this.expectedWork = '';
    }

  }


  getValue() {
    this.valueChange.emit({emplomentDetailFormValue:this.slideThreeForm.value,
      emplomentDetailFormIsValid:false,employementdetailform:this.slideThreeForm});
  }

  populateDataForEdit(data,modeOfOpeartion){

    console.log(data);
   debugger;
    this.modeOfOperation=modeOfOpeartion;
    let primary_employementdetail:any;
    let primary_additional_primary_employementdetail:any=[];
    if(data.length > 0){
      for(var i=0;i<data.length;i++)
      {

        if(data[i].type == 'primary'){

          if(data[i].contact_details.employment_details) {
            primary_employementdetail=data[i].contact_details.employment_details;
            this.employment_details=data[i].contact_details.employment_details;
          }

        }
        else{
           if(data[i].contact_details.employment_details) {
            primary_additional_primary_employementdetail.push(data[i].contact_details.employment_details);
           }
           else {
            this.formApplicantEmployment.push(this.initaddAnotherApplicantEmployment());
           }

        }
      }
  }

   console.log(primary_employementdetail);
   console.log(primary_additional_primary_employementdetail);

   if(primary_employementdetail) {
    if(Object.keys(primary_employementdetail).length > 0){
      this.slideThreeForm.get('employementType').setValue(primary_employementdetail.employementType);
      this.slideThreeForm.get('currentlyEmployment').setValue(primary_employementdetail.currentlyEmployment);
      this.slideThreeForm.get('statusyourEmployment').setValue(primary_employementdetail.statusyourEmployment);
      this.slideThreeForm.get('your_occupation').setValue(primary_employementdetail.your_occupation);
      this.slideThreeForm.get('start_date').setValue(primary_employementdetail.start_date);
      this.slideThreeForm.get('business_name').setValue(primary_employementdetail.business_name);
      this.slideThreeForm.get('type_of_entity').setValue(primary_employementdetail.type_of_entity);
      this.slideThreeForm.get('abn_acn').setValue(primary_employementdetail.abn_acn);
      this.slideThreeForm.get('nature_of_business').setValue(primary_employementdetail.nature_of_business);
      this.slideThreeForm.get('expectFindWork').setValue(primary_employementdetail.expectFindWork);
      this.isCurrentEmployeed = primary_employementdetail.currentlyEmployment;
      this.employementType = primary_employementdetail.employementType;

      if(this.isCurrentEmployeed == 'no' && this.employementType == 'payg') {

        this.slideThreeForm.get('statusyourEmployment').setValidators(null);
        this.slideThreeForm.get('start_date').setValidators(null);
        this.slideThreeForm.get('your_occupation').setValidators(null);

        // if(primary_employementdetail.start_date !== '') {
        //   this.slideThreeForm.get('start_date').setValidators(null);
        // }
        // if(primary_employementdetail.your_occupation !== '') {
        //   this.slideThreeForm.get('your_occupation').setValidators(null);
        // }




      }
      else {
        //this.slideThreeForm.get('currentlyEmployment').setValidators(null);

        // this.slideThreeForm.get('employementType').setValidators(null);

        // if(primary_employementdetail.start_date !== '') {
        //   this.slideThreeForm.get('start_date').setValidators(null);
        // }
        // if(primary_employementdetail.your_occupation !== '') {
        //   this.slideThreeForm.get('your_occupation').setValidators(null);
        // }

        //this.slideThreeForm.get('start_date').setValidators(null);

        this.slideThreeForm.get('statusyourEmployment').setValidators(null);
        this.slideThreeForm.get('start_date').setValidators(null);

        //this.slideThreeForm.get('your_occupation').clearValidators(); //your_occupation
        //this.slideThreeForm.get('your_occupation').updateValueAndValidity();


      }

      if(primary_employementdetail.addPrimaryEmploymentItem) {
        if(primary_employementdetail.addPrimaryEmploymentItem.length > 0 ) {

          primary_employementdetail.addPrimaryEmploymentItem.forEach((element,index) => {
            this.formPrimaryEmployment.push(this.initaddAnotherApplicantEmployment2(element));
            let employementType = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('employementType');

            if(employementType == 'payg') {
                let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
                gcurrentlyEmployment.clearValidators(); //expectFindWork
                gcurrentlyEmployment.updateValueAndValidity(); //expectFindWork

                let expectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
                expectFindWork.clearValidators(); //expectFindWork
                expectFindWork.updateValueAndValidity(); //expectFindWork


                let business_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');
                business_name.clearValidators(); //expectFindWork
                business_name.updateValueAndValidity(); //expectFindWork


                let nature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');
                nature_of_business.clearValidators(); //expectFindWork
                nature_of_business.updateValueAndValidity(); //expectFindWork

                let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');

                gstatusyourEmployment.setValidators([Validators.required])
                gstatusyourEmployment.updateValueAndValidity()

                let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');

                gyour_occupation.setValidators([Validators.required])
                gyour_occupation.updateValueAndValidity()

                let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');

                gstart_date.setValidators([Validators.required])
                gstart_date.updateValueAndValidity()


            }

            else if(employementType == 'self-employed') {

              let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
              gcurrentlyEmployment.clearValidators(); //expectFindWork
              gcurrentlyEmployment.updateValueAndValidity(); //expectFindWork

              let expectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
              expectFindWork.clearValidators(); //expectFindWork
              expectFindWork.updateValueAndValidity(); //expectFindWork


              let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
              gyour_occupation.clearValidators(); //expectFindWork
              gyour_occupation.updateValueAndValidity(); //business_name


              let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
              gstart_date.clearValidators(); //expectFindWork
              gstart_date.updateValueAndValidity(); //nature_of_business

              let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');

              gstatusyourEmployment.clearValidators(); //expectFindWork
              gstatusyourEmployment.updateValueAndValidity(); //nature_of_business

              let business_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');

              business_name.setValidators([Validators.required])
              business_name.updateValueAndValidity()

              let nature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');

              nature_of_business.setValidators([Validators.required])
              nature_of_business.updateValueAndValidity()


            }

            else {
              let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
              gcurrentlyEmployment.clearValidators(); //expectFindWork
              gcurrentlyEmployment.updateValueAndValidity(); //expectFindWork

              let expectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
              expectFindWork.clearValidators(); //expectFindWork
              expectFindWork.updateValueAndValidity(); //expectFindWork


              let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
              gyour_occupation.clearValidators(); //expectFindWork
              gyour_occupation.updateValueAndValidity(); //business_name


              let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
              gstart_date.clearValidators(); //expectFindWork
              gstart_date.updateValueAndValidity(); //nature_of_business

              let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');

              gstatusyourEmployment.clearValidators(); //expectFindWork
              gstatusyourEmployment.updateValueAndValidity(); //nature_of_business

              let business_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');

              business_name.clearValidators(); //expectFindWork
              business_name.updateValueAndValidity(); //nature_of_business

              let nature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');

              nature_of_business.clearValidators(); //expectFindWork
              nature_of_business.updateValueAndValidity(); //nature_of_business


            }



            // let start_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
            //   start_date.clearValidators(); //expectFindWork
            //   start_date.updateValueAndValidity(); //expectFindWork

            //   let statusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');
            //   statusyourEmployment.clearValidators(); //expectFindWork
            //   statusyourEmployment.updateValueAndValidity(); //expectFindWork

            //   let your_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
            //   your_occupation.clearValidators(); //expectFindWork
            //   your_occupation.updateValueAndValidity(); //expectFindWork

          });



        }
      }


    }
   }


  if(primary_additional_primary_employementdetail.length > 0)
  {
    primary_additional_primary_employementdetail.forEach((element,index)=>{

     let z=this.initaddAnotherApplicantEmployment2(element);

     (<FormArray>this.slideThreeForm.get('addEmploymentItem')).push(z);

     let isCurrentEmployeed = element.currentlyEmployment;
    let employementType = element.employementType;


      if(isCurrentEmployeed == 'no' && employementType == 'payg') {

            console.log('its working');
        // if(element.start_date !== '') {
        //   (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('start_date').setValidators(null);
        // }
        // if(element.your_occupation !== '') {
        //   (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('your_occupation').setValidators(null);
        // }
        // (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('start_date').setValidators(null);
        // (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('your_occupation').setValidators(null);

        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('start_date').clearValidators();
        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('start_date').updateValueAndValidity();
        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('your_occupation').clearValidators();
        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('your_occupation').updateValueAndValidity();
        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('statusyourEmployment').clearValidators();
        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('statusyourEmployment').updateValueAndValidity();




      }
      else {




        // if(element.start_date !== '') {
        //   (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('start_date').setValidators(null);
        // }
        // if(element.your_occupation !== '') {
        //   (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('your_occupation').setValidators(null);
        // }
        // (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('currentlyEmployment').setValidators(null);

        // (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('employementType').setValidators(null);

        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('statusyourEmployment').clearValidators();
        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('statusyourEmployment').updateValueAndValidity();

        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('start_date').clearValidators();
        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('start_date').updateValueAndValidity();

        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('currentlyEmployment').clearValidators();
        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('currentlyEmployment').updateValueAndValidity();

        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('your_occupation').clearValidators();
        (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('your_occupation').updateValueAndValidity();

        //(<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('your_occupation').setValidators(null);

        //(<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(index).get('start_date').setValidators(null);
      }

      console.log(element);
     // debugger;
      if(element.previousEmploymentItem) {
        if(element.previousEmploymentItem.length > 0 ) {

          element.previousEmploymentItem.forEach((newelement,adindex) => {
            this.additionprevAddres(index).push(this.initaddAnotherApplicantEmployment2(newelement));
            let gcurrentlyEmployment = this.additionprevAddres(index).at(adindex).get('currentlyEmployment');
            gcurrentlyEmployment.setValidators(null); // expectFindWork
            gcurrentlyEmployment.updateValueAndValidity();

            let expectFindWork = this.additionprevAddres(index).at(adindex).get('expectFindWork');
            expectFindWork.setValidators(null);
            expectFindWork.updateValueAndValidity();

            let gstatusyouemployemnet = this.additionprevAddres(index).at(adindex).get('statusyourEmployment');
            gstatusyouemployemnet.setValidators(null);
            gstatusyouemployemnet.updateValueAndValidity();

            let gyouroccupation = this.additionprevAddres(index).at(adindex).get('your_occupation');
            gyouroccupation.setValidators(null);
            gyouroccupation.updateValueAndValidity();

            let gstartdate = this.additionprevAddres(index).at(adindex).get('start_date');
            gstartdate.setValidators(null);
            gstartdate.updateValueAndValidity();
          });
         // this.slideThreeForm.get('statusyourEmployment').setValidators(null);
        }
      }



    })

    console.log(this.slideThreeForm);
    debugger;
  }

  }

  // additionprevAddres(): FormArray {
  //   return this.slideThreeForm.get('addEmploymentItem') as FormArray;
  // }

  additionprevAddres(appIndex: number): FormArray {
    return (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(appIndex).get("previousEmploymentItem") as FormArray
  }

  additionPrimaryprevAddres(appIndex: number): FormArray {
    return (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(appIndex).get("addPrimaryEmploymentItem") as FormArray
  }

  changeEmploymentTypePrev($event, index){

    debugger;
    let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
    let gexpectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
    let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
    let gbusiness_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');
    let gnature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');
    if($event == 'payg'){
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators([Validators.required])
      gstatusyourEmployment.updateValueAndValidity()

      gyour_occupation.setValidators([Validators.required])
      gyour_occupation.updateValueAndValidity()

      gstart_date.setValidators([Validators.required])
      gstart_date.updateValueAndValidity()
    }
    else if($event == 'self-employed'){
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      // gbusiness_name.setValidators(null);
      // gnature_of_business.setValidators(null);
      this.removePreviousEmployment(index);

      gbusiness_name.setValidators([Validators.required])
      gbusiness_name.updateValueAndValidity()

      gnature_of_business.setValidators([Validators.required])
      gnature_of_business.updateValueAndValidity()

    }
    else if($event == 'unemployed'){
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      this.removePreviousEmployment(index);

    }else{

      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(Validators.required);
      gnature_of_business.setValidators(Validators.required);
    }

    gcurrentlyEmployment.updateValueAndValidity();
    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();

    console.log(this.slideThreeForm);


  }

  currentEmployeedaddi(value, index){
    debugger;
    let gexpectFindWork = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('your_occupation');
    let gstart_date = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('start_date');
    let gbusiness_name = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('business_name');
    let gnature_of_business = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('nature_of_business');
    if(value == 'yes'){

      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);
      let emitdata = {
        status:'yes',
        index:index
      }
      this.addincomeChange.emit(emitdata)
    }else{

      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      let emitdata = {
        status:'no',
        index:index
      }
      this.addincomeChange.emit(emitdata)
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();

  }


  getEmployementDetail(employemnetDetailData){
    debugger;
    if(employemnetDetailData) {
      if(Object.keys(employemnetDetailData).length > 0)
      {
        this.employment_details=employemnetDetailData;

      }
      else{
        let obj={
          abn_acn:"",
          addPrimaryEmploymentItem:[],
          business_name:"",
          created_date:"",
          currentlyEmployment:"",
          deleted:0,
          employementType:"",
          expectFindWork:"",
          incomes:"",
          nature_of_business:"",
          start_date:"",
          statusyourEmployment:"",
          type_of_entity:"",
          your_occupation:""
        }
        this.employment_details=obj;

      }
    }
    else {
      let obj={
        abn_acn:"",
        addPrimaryEmploymentItem:[],
        business_name:"",
        created_date:"",
        currentlyEmployment:"",
        deleted:0,
        employementType:"",
        expectFindWork:"",
        incomes:"",
        nature_of_business:"",
        start_date:"",
        statusyourEmployment:"",
        type_of_entity:"",
        your_occupation:""
      }
      this.employment_details=obj;
    }



  }
  initaddAnotherApplicant(adfobj) {

    return this.formBuilder.group({

      secondary_firstname: [adfobj.secondary_firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [adfobj.secondary_middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [adfobj.secondary_lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [adfobj.secondary_email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [adfobj.secondary_mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [adfobj.secondary_date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  initaddAnotherApplicant_new(adfobj) {

    return this.formBuilder.group({

      secondary_firstname: [adfobj.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [adfobj.middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [adfobj.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [adfobj.email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [adfobj.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [adfobj.date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [adfobj.uid],
      document_id: ['']
    });
  }
  get primaryApplicantdata() {
    return this.primaryData.get('addAnotherApplicantItem') as FormArray;
  }
  setEmploymentDetails(primaryDetails) {

    this.primaryData.controls.firstname.setValue(primaryDetails.value.firstname);
    this.primaryData.controls.lastname.setValue(primaryDetails.value.lastname);
    primaryDetails.value.addAnotherApplicantItem.forEach((element,index) => {
      if(this.primaryApplicantdata.value[index]) {
        this.primaryApplicantdata.value[index].secondary_firstname = element.secondary_firstname;
        this.primaryApplicantdata.value[index].secondary_lastname = element.secondary_lastname;
        }
        else {
          this.primaryApplicantdata.push(this.initaddAnotherApplicant(element));
        }
    });


  }

  setAddiEmploymentDetails(additionalDetail) {

    this.primaryApplicantdata.at(additionalDetail.additional_index).get('secondary_firstname').setValue(additionalDetail.user_data.firstname);
    this.primaryApplicantdata.at(additionalDetail.additional_index).get('secondary_lastname').setValue(additionalDetail.user_data.lastname);
    debugger;

    if((<FormArray>(<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('previousEmploymentItem'))) {
      while ((<FormArray>(<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('previousEmploymentItem')).length !== 0) {
        (<FormArray>(<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('previousEmploymentItem')).removeAt(0);
      }
    }


    console.log((<FormArray>this.slideThreeForm.get('addEmploymentItem')));

    console.log(this.slideThreeForm.get('addEmploymentItem'));

    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('employementType').setValue(additionalDetail.contact_details.employment_details.employementType);
    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('currentlyEmployment').setValue(additionalDetail.contact_details.employment_details.currentlyEmployment);
    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('statusyourEmployment').setValue(additionalDetail.contact_details.employment_details.statusyourEmployment);
    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('start_date').setValue(additionalDetail.contact_details.employment_details.start_date);
    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('expectFindWork').setValue(additionalDetail.contact_details.employment_details.expectFindWork);
    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('type_of_entity').setValue(additionalDetail.contact_details.employment_details.type_of_entity);
    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('abn_acn').setValue(additionalDetail.contact_details.employment_details.abn_acn);
    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('nature_of_business').setValue(additionalDetail.contact_details.employment_details.nature_of_business);
    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('your_occupation').setValue(additionalDetail.contact_details.employment_details.your_occupation);
    (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('business_name').setValue(additionalDetail.contact_details.employment_details.business_name);
    let isCurrentEmployeed = additionalDetail.contact_details.employment_details.currentlyEmployment;
    let employementType = additionalDetail.contact_details.employment_details.employementType;

    if(isCurrentEmployeed == 'no' && employementType == 'payg') {


      (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('statusyourEmployment').clearValidators();
      (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('statusyourEmployment').updateValueAndValidity();

      (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('your_occupation').clearValidators();
      (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('your_occupation').updateValueAndValidity();

      (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('start_date').clearValidators();
      (<FormArray>this.slideThreeForm.get('addEmploymentItem')).at(additionalDetail.additional_index).get('start_date').updateValueAndValidity();

    }

    if(additionalDetail.contact_details.employment_details.addPrimaryEmploymentItem) {

      if(additionalDetail.contact_details.employment_details.addPrimaryEmploymentItem.length > 0 ) {

        additionalDetail.contact_details.employment_details.addPrimaryEmploymentItem.forEach((newelement,adindex) => {

          this.additionprevAddres(additionalDetail.additional_index).push(this.initaddAnotherApplicantEmployment2(newelement));
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('employementType').setValue(additionalDetail.contact_details.employment_details.employementType);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('currentlyEmployment').setValue(additionalDetail.contact_details.employment_details.currentlyEmployment);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('statusyourEmployment').setValue(additionalDetail.contact_details.employment_details.statusyourEmployment);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('start_date').setValue(additionalDetail.contact_details.employment_details.start_date);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('expectFindWork').setValue(additionalDetail.contact_details.employment_details.expectFindWork);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('type_of_entity').setValue(additionalDetail.contact_details.employment_details.type_of_entity);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('abn_acn').setValue(additionalDetail.contact_details.employment_details.abn_acn);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('nature_of_business').setValue(additionalDetail.contact_details.employment_details.nature_of_business);


          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('currentlyEmployment').setValue(newelement.currentlyEmployment);

          let gcurrentlyEmployment = this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('currentlyEmployment');
          gcurrentlyEmployment.setValidators(null);

          let gstatusyouemployemnet = this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('statusyourEmployment');
          gstatusyouemployemnet.setValidators(null);

          let gyouroccupation = this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('your_occupation');
          gyouroccupation.setValidators(null);

          let gstartdate = this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('start_date');
          gstartdate.setValidators(null);
        });

      }

    }

    if(additionalDetail.contact_details.employment_details.previousEmploymentItem) {

      if(additionalDetail.contact_details.employment_details.previousEmploymentItem.length > 0 ) {

        additionalDetail.contact_details.employment_details.previousEmploymentItem.forEach((newelement,adindex) => {

          //this.additionPrimaryprevAddres(additionalDetail.additional_index).push(this.initaddAnotherApplicantEmployment2(newelement))
          this.additionprevAddres(additionalDetail.additional_index).push(this.initaddAnotherApplicantEmployment2(newelement));
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('employementType').setValue(additionalDetail.contact_details.employment_details.employementType);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('currentlyEmployment').setValue(additionalDetail.contact_details.employment_details.currentlyEmployment);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('statusyourEmployment').setValue(additionalDetail.contact_details.employment_details.statusyourEmployment);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('start_date').setValue(additionalDetail.contact_details.employment_details.start_date);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('expectFindWork').setValue(additionalDetail.contact_details.employment_details.expectFindWork);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('type_of_entity').setValue(additionalDetail.contact_details.employment_details.type_of_entity);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('abn_acn').setValue(additionalDetail.contact_details.employment_details.abn_acn);
          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('nature_of_business').setValue(additionalDetail.contact_details.employment_details.nature_of_business);


          // this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('currentlyEmployment').setValue(newelement.currentlyEmployment);

          let gcurrentlyEmployment = this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('currentlyEmployment');
          gcurrentlyEmployment.setValidators(null);

          let gstatusyouemployemnet = this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('statusyourEmployment');
          gstatusyouemployemnet.setValidators(null);

          let gyouroccupation = this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('your_occupation');
          gyouroccupation.setValidators(null);

          let gstartdate = this.additionprevAddres(additionalDetail.additional_index).at(adindex).get('start_date');
          gstartdate.setValidators(null);
        });

      }

    }



  }

  setAdditionalDetails(data){
     console.log(data);
     debugger;
      data.forEach((element,index) => {
          if(element.type == "additional") {

              if(this.primaryApplicantdata.value[index]) {
              this.primaryApplicantdata.value[index].secondary_firstname = element.user_data.firstname;
              this.primaryApplicantdata.value[index].secondary_lastname = element.user_data.lastname;
              }
              else {
                this.primaryApplicantdata.push(this.initaddAnotherApplicant_new(element.user_data));
              }
          }

      });
    }


}




// WEBPACK FOOTER //
// ./src/pages/adf-page/component/employment-and-incomedetails/employment-details/employment_details.ts